import { useState, useEffect } from "react";
import { Modal, Space, Typography } from "antd";
import clsx from "clsx";
import { VectorSuccessIcon } from "@/shared/assets/svg/icons";
import "./add-to-package-modal.scss";

export type DocumentPackageOption = {
  id: string;
  name: string;
  selected: boolean;
};

type AddToPackageModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (selectedPackages: string[]) => void;
  availablePackages: DocumentPackageOption[];
  cardTitle?: string;
};

export const AddToPackageModal = ({
  open,
  onClose,
  onConfirm,
  availablePackages,
  cardTitle,
}: AddToPackageModalProps) => {
  const [selectedPackages, setSelectedPackages] = useState<string[]>([]);

  useEffect(() => {
    if (open) {
      // "Все" всегда выбран по умолчанию и его нельзя снять
      const defaultSelected = availablePackages
        .filter((pkg) => pkg.selected || pkg.id === "all")
        .map((pkg) => pkg.id);
      setSelectedPackages(defaultSelected);
    }
  }, [open, availablePackages]);

  const handlePackageToggle = (packageId: string) => {
    if (packageId === "all") {
      // "Все" нельзя снимать
      return;
    }

    setSelectedPackages((prev) =>
      prev.includes(packageId)
        ? prev.filter((id) => id !== packageId)
        : [...prev, packageId],
    );
  };

  const handleConfirm = () => {
    onConfirm(selectedPackages);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      title="Добавление в пакет документов"
      open={open}
      onOk={handleConfirm}
      onCancel={handleCancel}
      okText="Добавить в выбранные"
      cancelText="Отмена"
      className="add-to-package-modal"
      width={600}
    >
      <div className="add-to-package-modal__content">
        <Typography.Text className="add-to-package-modal__question">
          В какой пакет документов вы хотите добавить
        </Typography.Text>
        <Typography.Title
          level={5}
          className="add-to-package-modal__card-title"
        >
          {cardTitle || "Получение замечаний о регистрации титульного листа?"}
        </Typography.Title>

        <div className="add-to-package-modal__packages">
          {availablePackages.map((pkg) => (
            <div
              key={pkg.id}
              className={clsx("add-to-package-modal__package-item", selectedPackages.includes(pkg.id) && "add-to-package-modal__package-item--selected")}
              onClick={() => handlePackageToggle(pkg.id)}
            >
              <Space align="center">
                <div className="add-to-package-modal__package-checkbox">
                  {selectedPackages.includes(pkg.id) && <VectorSuccessIcon />}
                </div>
                <Typography.Text className="add-to-package-modal__package-name">
                  {pkg.name}
                </Typography.Text>
              </Space>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

